import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DroitsService } from 'src/app/services/droits/droits.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { UserService } from 'src/app/services/user/user.service';
import { EtatDeploiementEnum } from 'src/app/utils/interfaces/new/cabinet.interface';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';

@Component({
  selector: 'app-login-selection-profil',
  templateUrl: './login-selection-profil.component.html',
  styleUrls: ['./login-selection-profil.component.scss']
})
export class LoginSelectionProfilComponent implements OnInit {
  public profilForm: FormGroup;
  public profils: Profil[];
  public idUser: string;
  public user: Utilisateur;
  public search = '';

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private viewContainerRef: ViewContainerRef,
    private loginService: LoginService,
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    public droitService: DroitsService,
    private _snack: SnackbarService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.profilForm = this.formBuilder.group({
      profil: ['', [Validators.required]]
    });
    this.idUser = this.activatedRoute.snapshot.paramMap.get('id');
    this.profils = await this.userService.findMyProfils();
  }

  public async onSubmit(): Promise<void> {
    this.profilForm.markAllAsTouched();
    if (this.profilForm.valid) {
      const loadingModal = this.modalService.openLoading(this.viewContainerRef);
      try {
        const profil = await this.authService.selectProfil(this.profilForm.controls.profil.value.id);
        const localAuth: LocalAuth = {
          utilisateur: this.loginService.getCurrentUser(),
          profil,
        };
        this.loginService.saveCurrentProfil(profil);
        this.loginService.saveAuth(localAuth);
        this.loginService.resetSessionFlags();

        const combinatedRights = await this.droitService.findMyCombinedDroits();
        if (!combinatedRights.espacePerso) {
          this.router.navigateByUrl(`/select-docteur`);
        } else {
          if (profil) {
            if (!profil.cabinet) {
              this.router.navigateByUrl(`/stop-page/generic`);
            } else if (profil.cabinet.disabled) {
              this.router.navigateByUrl(`/stop-page/disabled`);
            } else if (profil.cabinet.etatDeploiement !== EtatDeploiementEnum.Deploye) {
              this.router.navigateByUrl('/stop-page/not-deployed');
            } else {
              this.router.navigateByUrl('/home');
            }
          } else {
            this.router.navigateByUrl('/stop-page/generic');
          }
        }
      } catch (e) {
        this._snack.openSnackBar(e.error || e.error?.message || e.message || 'Une erreur est survenue lors de la sélection du profil.');
        throw e;
      } finally {
        this.modalService.close(loadingModal);
      }
    }
  }

}
